const CompareTableLayout = ({ compareFields }) => {
  return (
    <div className="brandy-compare-table compare-table-content-wrapper">
      <div className="compare-table-container">
        <table className="compare-table"></table>
      </div>
    </div>
  );
};

export default CompareTableLayout;
